<!-- <div class="hw-box-content">
  <div class="hw-header-wrap">
    <div class="row">
      <div class="col-6">
        <i class="fn-global-site"></i>
        Help Videos
      </div>
    </div>
  </div>
  <div class="hw-content">
    <div class="row">
      <div class="col-12">
        <div class="table-container">
          <table class="table table-bordered fixed-layout m-0">
            <colgroup>
              <col style="width: 50%" />
              <col style="width: 50%" />
            </colgroup>
            <thead>
              <tr>
                <th class="text-center">Video Description</th>
                <th class="text-center">Video URL</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of descData; let i = index">
                <td
                  class="text-center text-truncate"
                  title="{{ row.description }}"
                >
                  {{ row.description }}
                </td>
                <td class="text-center">
                  <i
                    class="fn-global-video blue cursor-pointer mr-5"
                    (click)="actionOnVideo(row.url)"
                  ></i>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div> -->

<div class="hw-box-content">
  <div class="hw-header-wrap">
    <div class="row">
      <div class="col-6">
        <i class="fn-global-site"></i>
        Help Videos
      </div>
    </div>
  </div>
  <div class="hw-content">
    <div class="row">
      <div class="col-4" *ngFor="let row of descData; let i = index">
        <div class="card" style="margin-top:1%">
          <video
            width="100%"
            height="200"
            controls
            [src]="row.safeUrl"
            (play)="onVideoPlay($event)"
          ></video>
          <div class="card-body">
            <p class="card-text text-truncate text-bold" title="{{ row.description }}">
              {{ row.description }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>